import { DateTime } from 'luxon';
import { FC } from 'react';
import styled from 'styled-components';

// import { ReactComponent as HyperlinkIcon } from '@/assets/icons/hyperlink.svg';
import Image from '@/components/Image';
import { Td } from '@/components/Table';
import Text from '@/components/Text';
import { IgPost } from '@/types/resources';
import { numFormatter } from '@/utils/helpers';

const Thumbnail = styled(Image)`
  max-width: 100%;
  height: auto;
  width: auto;
`;

const Time = styled(Text)`
  margin-top: 4px;
`;

// const Type = styled.span`
//   text-transform: capitalize;
// `;

// const HyperLink = styled('a').attrs({
//   rel: 'noreferrer noopener',
//   target: '_blank',
// })`
//   display: inline-flex;
//   align-items: center;
//   max-width: 100%;
//   svg {
//     margin-right: 6px;
//     width: 14px;
//     flex-shrink: 0;
//   }
//   > span {
//     overflow-x: hidden;
//     text-overflow: ellipsis;
//   }
// `;

interface Props {
  post: IgPost;
}

const TableRow: FC<Props> = ({ post }) => {
  return (
    <tr>
      <Td>
        <a target="_blank" rel="noreferrer noopener" href={post.link}>
          <Thumbnail src={post.thumbnail} />
        </a>
      </Td>
      <Td>{post.likesAvgRatio !== null ? `${post.likesAvgRatio}%` : '-'}</Td>
      <Td>{post.likes ? numFormatter(post.likes) : '-'}</Td>
      {/* <Td>{post.views ? numFormatter(post.views) : '-'}</Td>
      <Td>{post.viewsPercentile ? `${post.viewsPercentile}%` : '-'}</Td> */}
      {/* <Td>
        <Type>{post.type}</Type>
      </Td> */}
      {/* <Td>{post.caption ?? '-'}</Td> */}
      <Td>{post.comments ? numFormatter(post.comments) : '-'}</Td>
      {/* <Td>{post.commentsPercentile ? `${post.commentsPercentile}%` : '-'}</Td>
      <Td>{post.likes ? numFormatter(post.likes) : '-'}</Td>
      <Td>{post.likesPercentile ? `${post.likesPercentile}%` : '-'}</Td> */}
      {/* <Td>
        <HyperLink href={`https://instagram.com/${post.username}`}>
          <HyperlinkIcon />
          <span>{post.username}</span>
        </HyperLink>
      </Td> */}
      <Td>
        {DateTime.fromISO(post.publishedAt).toLocaleString()} <br />
        <Time $color="gray" $type="extraSmall">
          {DateTime.fromISO(post.publishedAt).toFormat('HH:mm')}
        </Time>
      </Td>
      {/* <Td>
        {DateTime.fromISO(post.updatedAt).toLocaleString()} <br />
        <Time $color="gray" $type="extraSmall">
          {DateTime.fromISO(post.updatedAt).toFormat('HH:mm')}
        </Time>
      </Td> */}
    </tr>
  );
};

export default TableRow;
